import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import useOrgChartState, { IOrgChart } from '@/states/organization.state';
import useTenantState from '@/states/tenant.state';
import { errorHandler } from '@/utils/functions/errorHandler';

export const useOrgChartInit = () => {
  const { currentTenant } = useTenantState();
  const { fetchOrgCharts } = useOrgChartState();

  const [treeData, setTreeData] = useState<IOrgChart[] | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [hasData, setHasData] = useState<boolean | null>(null);

  const loadTree = async () => {
    if (!currentTenant?.id) return;
    setIsLoading(true);
    try {
      const data = await fetchOrgCharts(currentTenant.id);

      if (Array.isArray(data) && data.length > 0) {
        setTreeData(data);
        setHasData(true);
      } else {
        setTreeData(null);
        setHasData(false);
      }
    } catch (err) {
      errorHandler(err);
      setHasData(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadTree();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTenant?.id]);

  const createInitialNode = async () => {
    setTreeData([]);
    setHasData(true);
    toast.success('Silakan tambahkan jabatan per divisi dan level');
  };

  return {
    treeData,
    isLoading,
    setTreeData,
    hasData,
    createInitialNode,
    refreshTree: loadTree,
  };
};
